import type { Lang } from "@/types";

type Dict = Record<Lang, string>;

export const translations = {
  // Nav
  "nav.home": { fr: "Accueil", en: "Home" },
  "nav.products": { fr: "Produits", en: "Products" },
  "nav.menu": { fr: "Menu", en: "Menu" },
  "nav.catering": { fr: "Traiteur", en: "Catering" },
  "nav.resellers": { fr: "Points relais", en: "Resellers" },
  "nav.blog": { fr: "Journal", en: "Journal" },
  "nav.cart": { fr: "Panier", en: "Cart" },
  "nav.contact": { fr: "Contact", en: "Contact" },
  "nav.account": { fr: "Mon compte", en: "My account" },
  "nav.login": { fr: "Connexion", en: "Sign in" },

  // Auth
  "auth.loginTitle": { fr: "Connexion", en: "Sign in" },
  "auth.registerTitle": { fr: "Créer un compte", en: "Create account" },
  "auth.name": { fr: "Nom complet", en: "Full name" },
  "auth.email": { fr: "Adresse email", en: "Email address" },
  "auth.password": { fr: "Mot de passe", en: "Password" },
  "auth.loginBtn": { fr: "Se connecter", en: "Sign in" },
  "auth.registerBtn": { fr: "Créer mon compte", en: "Create account" },
  "auth.alreadyAccount": { fr: "Déjà un compte ?", en: "Already have an account?" },
  "auth.noAccount": { fr: "Pas encore de compte ?", en: "No account yet?" },
  "auth.logout": { fr: "Se déconnecter", en: "Sign out" },

  // Account
  "account.hello": { fr: "Bonjour", en: "Hello" },
  "account.tabs.info": { fr: "Mes infos", en: "My info" },
  "account.tabs.orders": { fr: "Commandes", en: "Orders" },
  "account.tabs.referrals": { fr: "Parrainage", en: "Referrals" },
  "account.name": { fr: "Nom complet", en: "Full name" },
  "account.currentPassword": { fr: "Mot de passe actuel", en: "Current password" },
  "account.newPassword": { fr: "Nouveau mot de passe", en: "New password" },
  "account.save": { fr: "Enregistrer", en: "Save" },
  "account.saved": { fr: "Enregistré !", en: "Saved!" },
  "account.noOrders": { fr: "Aucune commande pour l'instant.", en: "No orders yet." },
  "account.noReferrals": { fr: "Aucun code de parrainage.", en: "No referral codes yet." },
  "account.orderItems": { fr: "article(s)", en: "item(s)" },
  "account.copyCode": { fr: "Copier", en: "Copy" },
  "account.codeCopied": { fr: "Copié !", en: "Copied!" },
  "account.codeUses": { fr: "utilisations", en: "uses" },

  // Referral tab — Sprint 6
  "account.referral.yourCode": { fr: "Votre code parrainage", en: "Your referral code" },
  "account.referral.noCode": { fr: "Votre code sera créé automatiquement lors de votre prochain achat.", en: "Your code will be created automatically with your next purchase." },
  "account.referral.howItWorks": { fr: "Votre filleul bénéficie de −10% · vous gagnez −5€ sur votre prochaine commande.", en: "Your friend gets −10% off · you earn −5€ on your next order." },
  "account.referral.friendsCount": { fr: "ami(s) ont utilisé votre code", en: "friend(s) have used your code" },
  "account.referral.share": { fr: "Partager via WhatsApp", en: "Share via WhatsApp" },
  "account.referral.inactive": { fr: "inactif", en: "inactive" },
  "account.referral.otherCodes": { fr: "Autres codes", en: "Other codes" },
  "account.referral.savingsTitle": { fr: "Réductions reçues grâce à un ami", en: "Discounts received from a friend" },
  "account.referral.noSavings": { fr: "Vous n'avez pas encore utilisé de code parrainage.", en: "You haven't used a referral code yet." },
  "account.referral.codeUsed": { fr: "Code utilisé", en: "Code used" },
  "account.referral.saved": { fr: "Économisé", en: "Saved" },
  "account.order.viewDetail": { fr: "Voir le détail →", en: "View details →" },
  "account.order.backToAccount": { fr: "← Mon compte", en: "← My account" },
  "account.order.reference": { fr: "Réf.", en: "Ref." },
  "account.order.paid": { fr: "Payé", en: "Paid" },
  "account.order.pending": { fr: "En attente", en: "Pending" },
  "account.order.failed": { fr: "Échoué", en: "Failed" },
  "account.order.items": { fr: "Articles", en: "Items" },
  "account.order.total": { fr: "Total", en: "Total" },
  "account.order.notFound": { fr: "Commande introuvable.", en: "Order not found." },

  // Account — Addresses
  "account.tabs.addresses": { fr: "Adresses", en: "Addresses" },
  "account.addresses.noAddresses": { fr: "Aucune adresse sauvegardée.", en: "No saved addresses yet." },
  "account.addresses.add": { fr: "+ Ajouter une adresse", en: "+ Add an address" },
  "account.addresses.edit": { fr: "Modifier", en: "Edit" },
  "account.addresses.delete": { fr: "Supprimer", en: "Delete" },
  "account.addresses.setDefault": { fr: "Définir par défaut", en: "Set as default" },
  "account.addresses.default": { fr: "Par défaut", en: "Default" },
  "account.addresses.label": { fr: "Nom de l'adresse (ex. Maison)", en: "Label (e.g. Home)" },
  "account.addresses.fullName": { fr: "Nom du destinataire", en: "Recipient name" },
  "account.addresses.line1": { fr: "Adresse", en: "Street address" },
  "account.addresses.line2": { fr: "Complément (optionnel)", en: "Apt, suite… (optional)" },
  "account.addresses.city": { fr: "Ville", en: "City" },
  "account.addresses.postalCode": { fr: "Code postal", en: "Postal code" },
  "account.addresses.country": { fr: "Pays", en: "Country" },
  "account.addresses.phone": { fr: "Téléphone (optionnel)", en: "Phone (optional)" },
  "account.addresses.saveAddress": { fr: "Enregistrer l'adresse", en: "Save address" },
  "account.addresses.cancel": { fr: "Annuler", en: "Cancel" },
  "account.addresses.confirmDelete": { fr: "Supprimer cette adresse ?", en: "Delete this address?" },

  // Cart — shipping block
  "cart.shippingTo": { fr: "Livraison à", en: "Shipping to" },
  "cart.changeAddress": { fr: "Modifier →", en: "Change →" },

  // Home
  "home.eyebrow": { fr: "Maison camerounaise — depuis le terroir", en: "Cameroonian house — from the soil" },
  "home.hero.title": {
    fr: "Le goût du Cameroun, transmis avec patience.",
    en: "The taste of Cameroon, passed down with patience.",
  },
  "home.hero.sub": {
    fr: "AUDY COOK cultive les saveurs traditionnelles : du ndolé fumant aux épices d'antan, chaque recette est un héritage.",
    en: "AUDY COOK keeps traditional flavours alive: from steaming ndolé to age-old spices, every recipe is a heritage.",
  },
  "home.hero.cta1": { fr: "Découvrir les produits", en: "Discover products" },
  "home.hero.cta2": { fr: "Notre menu", en: "Our menu" },
  "home.marquee": {
    fr: "Authentique • Camerounais • Gastronomique • Authentique • Camerounais • Gastronomique",
    en: "Authentic • Cameroonian • Gastronomic • Authentic • Cameroonian • Gastronomic",
  },
  "home.story.eyebrow": { fr: "Notre histoire", en: "Our story" },
  "home.story.title": { fr: "Une cuisine née de la mémoire et du soleil.", en: "A cuisine born of memory and sun." },
  "home.story.body": {
    fr: "AUDY COOK est née de l'envie de partager les saveurs du Cameroun avec celles et ceux qui les portent dans le cœur. Nous travaillons en circuit court avec des productrices au pays, séchons au soleil, dosons à la main. Chaque sachet, chaque plat raconte une histoire.",
    en: "AUDY COOK was born from a desire to share Cameroonian flavours with those who carry them in their heart. We work directly with women producers in Cameroon, sun-dry our ingredients and measure by hand. Every pack, every plate tells a story.",
  },
  "home.products.eyebrow": { fr: "Produits du pays", en: "Country products" },
  "home.products.title": { fr: "Le terroir camerounais, prêt à cuisiner.", en: "Cameroonian terroir, ready to cook." },
  "home.products.cta": { fr: "Voir tous les produits", en: "Browse all products" },
  "home.menu.eyebrow": { fr: "Menu traditionnel", en: "Traditional menu" },
  "home.menu.title": { fr: "Sur commande, à partir de 5 plats.", en: "On order, from 5 plates." },
  "home.menu.body": {
    fr: "Réunions de famille, baptêmes, anniversaires : nous cuisinons à votre rythme. Réservez 48h à l'avance, dégustez à votre table.",
    en: "Family gatherings, christenings, birthdays — we cook at your pace. Book 48h ahead, enjoy at your table.",
  },
  "home.menu.cta": { fr: "Voir le menu", en: "View menu" },
  "home.catering.eyebrow": { fr: "Service gastronomique", en: "Gastronomic service" },
  "home.catering.title": { fr: "Vos événements, en pleine saveur.", en: "Your events, in full flavour." },
  "home.catering.cta": { fr: "Demander un devis", en: "Request a quote" },
  "home.blog.eyebrow": { fr: "Carnet culinaire", en: "Culinary journal" },
  "home.blog.title": { fr: "Recettes, conseils, mémoire.", en: "Recipes, tips, memory." },
  "home.blog.cta": { fr: "Lire le journal", en: "Read the journal" },

  // Products
  "products.title": { fr: "Produits du terroir", en: "Terroir products" },
  "products.sub": {
    fr: "Sélectionnés, séchés et conditionnés avec soin. Livrés depuis le Luxembourg vers l'Europe et au-delà.",
    en: "Selected, dried and packaged with care. Shipped from Luxembourg to Europe and beyond.",
  },
  "products.add": { fr: "Ajouter au panier", en: "Add to cart" },
  "products.added": { fr: "Ajouté", en: "Added" },
  "products.bestseller": { fr: "Bestseller", en: "Bestseller" },
  "products.new": { fr: "Nouveau", en: "New" },
  "products.from": { fr: "À partir de", en: "From" },
  "products.outOfStock": { fr: "Indisponible", en: "Sold out" },

  // Menu
  "menu.title": { fr: "Menu traditionnel", en: "Traditional menu" },
  "menu.sub": {
    fr: "Cuisine sur commande pour 5 personnes minimum. Préparé le jour même par notre cheffe.",
    en: "On-order cuisine for 5 people minimum. Prepared the same day by our chef.",
  },
  "menu.minQty": { fr: "Min.", en: "Min." },
  "menu.plates": { fr: "plats", en: "plates" },
  "menu.order": { fr: "Commander via WhatsApp", en: "Order via WhatsApp" },

  // Catering
  "catering.title": { fr: "Service gastronomique", en: "Catering & gastronomy" },
  "catering.sub": {
    fr: "Buffets, mariages, événements d'entreprise. Cuisine camerounaise authentique servie comme à Douala.",
    en: "Buffets, weddings, corporate events. Authentic Cameroonian cuisine served like in Douala.",
  },
  "catering.feature1.title": { fr: "Menus personnalisés", en: "Personalised menus" },
  "catering.feature1.body": { fr: "Création de menus sur mesure selon vos préférences et votre événement.", en: "Tailor-made menus to fit your preferences and event type." },
  "catering.feature2.title": { fr: "Service complet", en: "Complete service" },
  "catering.feature2.body": { fr: "Équipe professionnelle, matériel et service inclus.", en: "Professional team, equipment and service included." },
  "catering.feature3.title": { fr: "Cuisine authentique", en: "Authentic cuisine" },
  "catering.feature3.body": { fr: "Ingrédients frais, recettes traditionnelles, dressage soigné.", en: "Fresh ingredients, traditional recipes, careful plating." },
  "catering.feature4.title": { fr: "Flexibilité", en: "Flexibility" },
  "catering.feature4.body": { fr: "Adaptation à toutes contraintes alimentaires et logistiques.", en: "Adapts to any dietary and logistical constraints." },
  "catering.info.title": { fr: "À savoir", en: "Good to know" },
  "catering.info.li1": { fr: "Commande minimum 10 personnes", en: "Minimum order: 10 people" },
  "catering.info.li2": { fr: "Réservation 48h à l'avance minimum", en: "Booking minimum 48h ahead" },
  "catering.info.li3": { fr: "Service et matériel inclus", en: "Service and equipment included" },
  "catering.info.li4": { fr: "Devis gratuit et personnalisé", en: "Free, personalised quote" },
  "catering.cta": { fr: "Organiser mon événement", en: "Organise my event" },

  // Resellers
  "resellers.title": { fr: "Points relais & revendeurs", en: "Pickup points & resellers" },
  "resellers.sub": {
    fr: "Présents au Luxembourg, en Belgique, en Allemagne, au Cameroun et à Dubai. Expansion européenne en cours.",
    en: "Available in Luxembourg, Belgium, Germany, Cameroon and Dubai. European expansion in progress.",
  },
  "resellers.becomeReseller": { fr: "Devenir revendeur", en: "Become a reseller" },
  "resellers.findClosest": { fr: "Trouver un point relais", en: "Find a pickup point" },

  // Blog
  "blog.title": { fr: "Carnet culinaire", en: "Culinary journal" },
  "blog.sub": { fr: "Recettes, savoirs et histoires de cuisine camerounaise.", en: "Recipes, knowledge and stories of Cameroonian cooking." },
  "blog.readMore": { fr: "Lire la suite", en: "Read more" },
  "blog.minRead": { fr: "min de lecture", en: "min read" },
  "blog.share": { fr: "Partager cet article", en: "Share this article" },
  "blog.share.facebook": { fr: "Facebook", en: "Facebook" },
  "blog.share.twitter": { fr: "Twitter", en: "Twitter" },
  "blog.share.whatsapp": { fr: "WhatsApp", en: "WhatsApp" },
  "blog.share.copy": { fr: "Copier le lien", en: "Copy link" },
  "blog.share.copied": { fr: "Lien copié !", en: "Copied!" },

  // Cart
  "cart.title": { fr: "Votre panier", en: "Your cart" },
  "cart.empty": { fr: "Votre panier est vide.", en: "Your cart is empty." },
  "cart.continue": { fr: "Continuer mes achats", en: "Continue shopping" },
  "cart.subtotal": { fr: "Sous-total", en: "Subtotal" },
  "cart.total": { fr: "Total", en: "Total" },
  "cart.checkoutStripe": { fr: "Payer par carte", en: "Pay by card" },
  "cart.checkoutWhatsapp": { fr: "Commander via WhatsApp", en: "Order via WhatsApp" },
  "cart.remove": { fr: "Retirer", en: "Remove" },
  "cart.quantity": { fr: "Quantité", en: "Quantity" },
  "cart.shippingNote": { fr: "Frais de livraison calculés à la commande.", en: "Shipping calculated at checkout." },
  "cart.customerEmail": { fr: "Votre email (optionnel)", en: "Your email (optional)" },
  "cart.customerName": { fr: "Votre nom (optionnel)", en: "Your name (optional)" },
  "cart.referralCode": { fr: "Code parrainage", en: "Referral code" },
  "cart.referralPlaceholder": { fr: "ex. AUDY-AICHA-X8K2", en: "e.g. AUDY-AICHA-X8K2" },
  "cart.referralApply": { fr: "Appliquer", en: "Apply" },
  "cart.referralValid": { fr: "Code accepté · −10%", en: "Code accepted · −10%" },
  "cart.referralInvalid": { fr: "Code invalide", en: "Invalid code" },
  "cart.discount": { fr: "Réduction parrainage", en: "Referral discount" },

  // Checkout success
  "checkout.success.title": { fr: "Merci pour votre commande !", en: "Thank you for your order!" },
  "checkout.success.body": { fr: "Nous avons bien reçu votre paiement. Vous recevrez un email de confirmation sous peu.", en: "We have received your payment. A confirmation email will follow shortly." },
  "checkout.pending": { fr: "Vérification du paiement…", en: "Verifying payment…" },
  "checkout.failed": { fr: "Le paiement n'a pas abouti.", en: "Payment did not go through." },
  "checkout.backHome": { fr: "Retour à l'accueil", en: "Back to home" },
  "checkout.referral.title": { fr: "Votre code de parrainage", en: "Your referral code" },
  "checkout.referral.body": {
    fr: "Partagez votre code à un proche : il bénéficie de −10%, vous gagnez −5€ sur votre prochaine commande.",
    en: "Share your code with a friend: they get −10%, you earn −5€ on your next order.",
  },
  "checkout.referral.copy": { fr: "Copier", en: "Copy" },
  "checkout.referral.copied": { fr: "Copié !", en: "Copied!" },
  "checkout.referral.share": { fr: "Partager via WhatsApp", en: "Share via WhatsApp" },

  // Footer
  "footer.tagline": { fr: "Le Cameroun, à portée de table.", en: "Cameroon, within reach of your table." },
  "footer.contact": { fr: "Contact", en: "Contact" },
  "footer.hours": { fr: "Horaires", en: "Hours" },
  "footer.hours1": { fr: "Lun – Ven : 10h – 20h", en: "Mon – Fri: 10am – 8pm" },
  "footer.hours2": { fr: "Sam – Dim : 12h – 22h", en: "Sat – Sun: 12pm – 10pm" },
  "footer.hours3": { fr: "WhatsApp 24h/7j", en: "WhatsApp 24/7" },
  "footer.expansion": { fr: "Luxembourg • Belgique • Allemagne • Cameroun • Dubai", en: "Luxembourg • Belgium • Germany • Cameroon • Dubai" },
  "footer.rights": { fr: "Tous droits réservés.", en: "All rights reserved." },

  // Admin
  "admin.login.title": { fr: "Espace administrateur", en: "Admin space" },
  "admin.email": { fr: "Email", en: "Email" },
  "admin.password": { fr: "Mot de passe", en: "Password" },
  "admin.signIn": { fr: "Se connecter", en: "Sign in" },
  "admin.signOut": { fr: "Déconnexion", en: "Sign out" },
  "admin.dashboard": { fr: "Tableau de bord", en: "Dashboard" },
  "admin.products": { fr: "Produits", en: "Products" },
  "admin.menu": { fr: "Menu", en: "Menu" },
  "admin.blog": { fr: "Articles", en: "Articles" },
  "admin.referrals": { fr: "Parrainages", en: "Referrals" },
  "admin.referral.create": { fr: "Créer un code", en: "Create code" },
  "admin.referral.deactivate": { fr: "Désactiver", en: "Deactivate" },
  "admin.referral.activate": { fr: "Activer", en: "Activate" },
  "admin.referral.leaderboard": { fr: "Top parrains du mois", en: "Top referrers this month" },
  "admin.referral.ownerName": { fr: "Nom du parrain", en: "Owner name" },
  "admin.referral.ownerEmail": { fr: "Email du parrain", en: "Owner email" },
  "admin.referral.inactive": { fr: "inactif", en: "inactive" },
  "admin.customers": { fr: "Clients", en: "Customers" },
  "admin.customers.back": { fr: "← Retour", en: "← Back" },
  "admin.customers.registered": { fr: "Inscription", en: "Registered" },
  "admin.customers.orders": { fr: "Commandes", en: "Orders" },
  "admin.customers.totalSpent": { fr: "Total dépensé", en: "Total spent" },
  "admin.customers.status": { fr: "Statut", en: "Status" },
  "admin.customers.active": { fr: "Actif", en: "Active" },
  "admin.customers.suspended": { fr: "Suspendu", en: "Suspended" },
  "admin.customers.suspend": { fr: "Suspendre", en: "Suspend" },
  "admin.customers.activate": { fr: "Réactiver", en: "Reactivate" },
  "admin.customers.view": { fr: "Voir →", en: "View →" },
  "admin.customers.referralCodes": { fr: "Codes parrainage", en: "Referral codes" },
  "admin.customers.noOrders": { fr: "Aucune commande.", en: "No orders." },
  "admin.customers.noCodes": { fr: "Aucun code.", en: "No codes." },
  "admin.customers.confirmSuspend": { fr: "Suspendre ce compte ?", en: "Suspend this account?" },
  "admin.customers.confirmActivate": { fr: "Réactiver ce compte ?", en: "Reactivate this account?" },
  "admin.add": { fr: "Ajouter", en: "Add" },
  "admin.edit": { fr: "Éditer", en: "Edit" },
  "admin.delete": { fr: "Supprimer", en: "Delete" },
  "admin.save": { fr: "Enregistrer", en: "Save" },
  "admin.cancel": { fr: "Annuler", en: "Cancel" },
  "admin.confirmDelete": { fr: "Confirmer la suppression ?", en: "Confirm deletion?" },
  "admin.invalidLogin": { fr: "Identifiants invalides", en: "Invalid credentials" },
} satisfies Record<string, Dict>;

export type TranslationKey = keyof typeof translations;
